import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import DashboardLayout from '@/components/layout/DashboardLayout';
import { 
  Card, 
  CardContent, 
  CardDescription, 
  CardHeader, 
  CardTitle,
  CardFooter
} from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Shield, Home } from 'lucide-react';
import Breadcrumb from '@/components/common/Breadcrumb';

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>CSM | Trivium - Acesso Negado</title>
      </Helmet>
      <DashboardLayout>
      <div className="container mx-auto py-10">
        {/* Breadcrumb */}
        <div className="mb-4">
          <Breadcrumb 
            items={[
              { label: "Dashboard", href: "/" },
              { label: "Acesso Negado" }
            ]} 
          />
        </div>
        
        <div className="flex items-center justify-center">
          <Card className="w-full max-w-md">
            <CardHeader className="text-center">
              <div className="mx-auto bg-red-100 p-3 rounded-full w-16 h-16 flex items-center justify-center mb-4">
                <Shield className="h-8 w-8 text-red-600" />
              </div>
              <CardTitle className="text-2xl">Acesso Negado</CardTitle>
              <CardDescription>
                Você não tem permissão para acessar esta página.
              </CardDescription>
            </CardHeader>
            <CardContent className="text-center">
              <p className="mb-4">
                Esta página requer permissões específicas que não foram atribuídas ao seu usuário.
                Entre em contato com o administrador do sistema se você acredita que deveria ter acesso.
              </p>
            </CardContent>
            <CardFooter className="flex justify-center">
              <Button onClick={() => navigate('/')} className="gap-2">
                <Home className="h-4 w-4" />
                Voltar para o Dashboard
              </Button>
            </CardFooter>
          </Card>
        </div>
      </div>
    </DashboardLayout>
    </>
  );
};

export default Unauthorized; 